import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import * as React from 'react';
import Slide from '@mui/material/Slide';
import { useDispatch } from 'react-redux';
import { checkInstituteId, NewApplication } from '../features/auth/authSlice';
import Spinner from '../components/UIElements/Spinner';
import { useNavigate } from 'react-router-dom';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
const RegistrationPage = () => {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [showMobileServices, setShowMobileServices] = React.useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const schema = Yup.object({
    instituteName: Yup.string().required('Enter Institute Name'),
    instituteType: Yup.string().required('Enter Institute Type'),
    instituteId: Yup.string().required('Enter Institute Id'),
    location: Yup.string().required('Enter Locaiton'),
    emailId: Yup.string().email('Invalid email').required('Email is Required'),
    phoneNumber: Yup.string()
      .matches(/^[6-9]\d{9}$/, 'Enter a valid 10-digit Indian mobile number')
      .required('Enter Phone Nubmer'),
    fullName: Yup.string().required('Enter Full Name'),
    designation: Yup.string().required('Enter role ex:Admin'),
    logo: Yup.mixed().required('Select Institute Logo'),
  });
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction='bottom' ref={ref} {...props} />;
  });
  const InputRef = React.useRef();
  const mobileOptions = [
    { label: 'Exams', value: 'exams' },
    { label: 'Attendance', value: 'attendance' },
    { label: 'Announcements', value: 'announcements' },
    { label: 'Payments', value: 'payments' },
    { label: 'Reports', value: 'reports' },
    { label: 'Home Work', value: 'homeWork' },
  ];
  async function verifyInstituteId(id) {
    try {
      const resp = await dispatch(checkInstituteId(id)).unwrap();
      return resp;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <>
      <div className='   bg-white px-6 rounded-lg   container border '>
        <div className=' py-4'>
          <Formik
            initialValues={{
              instituteName: '',
              instituteType: '',
              instituteId: '',
              location: '',
              emailId: '',
              phoneNumber: '',
              fullName: '',
              designation: '',
              webAttendance: '',
              webMarks: '',
              smsService: '',
              mobileServices: '',
              // Logo
              logo: '',
            }}
            validationSchema={schema}
            onSubmit={async (values, { resetForm, setFieldError }) => {
              setLoading(true);
              const isError = await verifyInstituteId(values?.instituteId);
              if (isError) {
                setFieldError('instituteId', 'Institute id already exists!');
                setLoading(false);
              } else {
                try {
                  setLoading(true);
                  const response = await dispatch(
                    NewApplication(values),
                  ).unwrap();
                  if (response.status === 200 || response.status === 201) {
                    setOpen(true);
                    setShowMobileServices(false);
                    InputRef.current.value = '';
                    resetForm();
                  } else {
                    alert('something went wrong !');
                  }
                } catch (error) {
                  console.log(error);
                  alert('something went wrong !');
                } finally {
                  setLoading(false);
                }
              }
            }}
          >
            {({ setFieldValue, setFieldTouched, setFieldError, values }) => (
              <Form className=' relative '>
                <h1 className='text-center text-blue-400'>Registration Form</h1>
                <div className='flex gap-4 justify-center items-center  max-lg:flex-col mx-auto'>
                  <div className='max-w-md  lg:self-start'>
                    <Typography variant='h6'>Institution Details</Typography>
                    <Field name='instituteName'>
                      {({ field, meta }) => (
                        <TextField
                          size='small'
                          label='Institute Name'
                          fullWidth
                          margin='normal'
                          {...field}
                          error={meta.touched && Boolean(meta.error)}
                          helperText={meta.touched && meta.error}
                        />
                      )}
                    </Field>
                    <Field name='instituteType'>
                      {({ field, meta }) => (
                        <FormControl
                          fullWidth
                          margin='normal'
                          size='small'
                          error={meta.touched && Boolean(meta.error)}
                        >
                          <InputLabel>Institute Type</InputLabel>
                          <Select {...field} label='Institute Type'>
                            <MenuItem value=''>--Select Type--</MenuItem>
                            <MenuItem value='school'>School</MenuItem>
                            <MenuItem value='intermediate'>
                              Intermediate
                            </MenuItem>
                            <MenuItem value='college'>College</MenuItem>
                          </Select>
                          {meta.touched && meta.error && (
                            <FormHelperText>{meta.error}</FormHelperText>
                          )}
                        </FormControl>
                      )}
                    </Field>
                    <Field name='instituteId'>
                      {({ field, meta, form }) => (
                        <TextField
                          size='small'
                          label='Institute Id'
                          fullWidth
                          {...field}
                          onBlur={async (e) => {
                            if (field.value) {
                              field.onBlur(e);
                              const bool = await verifyInstituteId(field.value);
                              if (bool) {
                                form.setFieldError(
                                  'instituteId',
                                  'Institute Id already exists !',
                                );
                              } else
                                form.setFieldError('instituteId', undefined);
                            }
                          }}
                          margin='normal'
                          error={meta.touched && Boolean(meta.error)}
                          helperText={meta.touched && meta.error}
                        />
                      )}
                    </Field>
                    <Field name='location'>
                      {({ field, meta }) => (
                        <TextField
                          size='small'
                          label='Location or Address'
                          fullWidth
                          margin='normal'
                          {...field}
                          error={meta.touched && Boolean(meta.error)}
                          helperText={meta.touched && meta.error}
                        />
                      )}
                    </Field>
                  </div>
                  <div className='max-w-md  lg:self-start'>
                    <Typography variant='h6'>Login Details</Typography>
                    <Field name='emailId'>
                      {({ field, meta }) => (
                        <TextField
                          size='small'
                          label='Institute Email Id'
                          fullWidth
                          margin='normal'
                          {...field}
                          error={meta.touched && Boolean(meta.error)}
                          helperText={meta.touched && meta.error}
                        />
                      )}
                    </Field>

                    <Field name='phoneNumber'>
                      {({ field, meta }) => (
                        <TextField
                          size='small'
                          label='Phone Number'
                          fullWidth
                          margin='normal'
                          {...field}
                          error={meta.touched && Boolean(meta.error)}
                          helperText={meta.touched && meta.error}
                        />
                      )}
                    </Field>
                    <Field name='fullName'>
                      {({ field, meta }) => (
                        <TextField
                          size='small'
                          label='Full Name'
                          fullWidth
                          margin='normal'
                          {...field}
                          error={meta.touched && Boolean(meta.error)}
                          helperText={meta.touched && meta.error}
                        />
                      )}
                    </Field>
                    <Field name='designation'>
                      {({ field, meta }) => (
                        <TextField
                          size='small'
                          label='Role or Designation'
                          fullWidth
                          margin='normal'
                          {...field}
                          placeholder='Ex:Admin'
                          error={meta.touched && Boolean(meta.error)}
                          helperText={meta.touched && meta.error}
                        />
                      )}
                    </Field>
                  </div>
                </div>
                <div className='flex gap-4 justify-center items-center  max-lg:flex-col mt-4 mx-auto'>
                  <div className='max-w-md  lg:self-start  w-full '>
                    <Typography variant='body1' className='font-semibold'>
                      Default Services offered:
                    </Typography>
                    <Typography className='mb-2'>
                      Dashboard Analysis, Students Management, Payments,
                      Students History, Migration
                    </Typography>
                    <b>Other Services(optional):</b>
                    <Typography className='mb-2'>
                      Specify the services you would like use in the Application
                    </Typography>

                    <Field name='webAttendance'>
                      {({ field, form, meta }) => (
                        <>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={field.value}
                                onChange={(e) =>
                                  form.setFieldValue(
                                    field.name,
                                    e.target.checked,
                                  )
                                }
                              />
                            }
                            label='Attendance'
                          />
                          {meta.touched && meta.error && (
                            <FormHelperText error>{meta.error}</FormHelperText>
                          )}
                        </>
                      )}
                    </Field>
                    <Field name='webMarks'>
                      {({ field, form, meta }) => (
                        <>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={field.value}
                                onChange={(e) =>
                                  form.setFieldValue(
                                    field.name,
                                    e.target.checked,
                                  )
                                }
                              />
                            }
                            label='Marks'
                          />
                          {meta.touched && meta.error && (
                            <FormHelperText error>{meta.error}</FormHelperText>
                          )}
                        </>
                      )}
                    </Field>
                    <Field name='smsService'>
                      {({ field, form, meta }) => (
                        <>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={field.value}
                                onChange={(e) =>
                                  form.setFieldValue(
                                    field.name,
                                    e.target.checked,
                                  )
                                }
                              />
                            }
                            label='SMS Service'
                          />
                          {meta.touched && meta.error && (
                            <FormHelperText error>{meta.error}</FormHelperText>
                          )}
                        </>
                      )}
                    </Field>
                    <FormControlLabel
                      className='block'
                      control={
                        <Checkbox
                          checked={showMobileServices}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            if (checked) {
                              setShowMobileServices(true);
                              setFieldValue('mobileServices', []);
                            } else {
                              setShowMobileServices(false);
                              setFieldValue('mobileServices', '');
                            }
                          }}
                        />
                      }
                      label='Mobile Services'
                    />
                    {showMobileServices && (
                      <div className='pl-4'>
                        <Field name='mobileServices'>
                          {({ field, form, meta }) => (
                            <FormControl
                              error={meta.touched && Boolean(meta.error)}
                            >
                              <Typography variant='subtitle1'>
                                Select Specific Services
                              </Typography>
                              <div className='grid grid-cols-3  '>
                                {mobileOptions.map((option) => (
                                  <FormControlLabel
                                    key={option.value}
                                    control={
                                      <Checkbox
                                        checked={field.value.includes(
                                          option.value,
                                        )}
                                        onChange={(e) => {
                                          const checked = e.target.checked;
                                          const value = option.value;

                                          if (checked) {
                                            form.setFieldValue(field.name, [
                                              ...field.value,
                                              value,
                                            ]);
                                          } else {
                                            form.setFieldValue(
                                              field.name,
                                              field.value.filter(
                                                (v) => v !== value,
                                              ),
                                            );
                                          }
                                        }}
                                        onBlur={() =>
                                          form.setFieldTouched(field.name, true)
                                        }
                                      />
                                    }
                                    label={option.label}
                                  />
                                ))}
                              </div>

                              {meta.touched && meta.error && (
                                <FormHelperText>{meta.error}</FormHelperText>
                              )}
                            </FormControl>
                          )}
                        </Field>
                      </div>
                    )}
                  </div>
                  <div
                    className='size-full max-w-md self-center min-h-60 flex gap-4
                  bg-white hover:shadow-lg border-2  rounded-lg border-dashed  px-2 '
                  >
                    <div className='flex justify-center items-center w-1/3'>
                      {' '}
                      {!values.logo && (
                        <CloudUploadIcon className='size-16 text-blue-600' />
                      )}
                      {values.logo && (
                        <img
                          src={URL.createObjectURL(values.logo)}
                          alt='Preview'
                          className=' block  size-[140px] object-contain'
                          width={100}
                        />
                      )}
                    </div>
                    <div className=' flex  items-center justify-center w-2/3'>
                      <div className=' mt-2 '>
                        <Typography variant='h6'>
                          {' '}
                          Upload Institution Logo
                        </Typography>
                        <Field name='logo'>
                          {() => (
                            <>
                              <input
                                type='file'
                                ref={InputRef}
                                className=' w-full'
                                accept='image/*'
                                onChange={(e) => {
                                  const file = e.currentTarget.files?.[0];
                                  setFieldTouched('logo', true, false);
                                  if (file) {
                                    const allowedTypes = [
                                      'image/jpeg',
                                      'image/png',
                                      'image/jpg',
                                    ];
                                    const maxSize = 1 * 1024 * 1024;
                                    if (!allowedTypes.includes(file.type)) {
                                      setFieldError(
                                        'logo',
                                        'Only JPG and PNG files are allowed',
                                      );
                                      return;
                                    }
                                    if (file.size > maxSize) {
                                      setFieldError(
                                        'logo',
                                        'File too large (max 1MB)',
                                      );
                                      return;
                                    }
                                    setFieldValue('logo', file);
                                  } else {
                                    setFieldValue('logo', null);
                                  }
                                }}
                              />
                            </>
                          )}
                        </Field>
                        <ErrorMessage
                          name='logo'
                          component='div'
                          className='text-red-600 text-sm  '
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className='flex justify-center mt-4 gap-x-8 px-4'>
                  <Button
                    variant='outlined'
                    color='error'
                    type='reset'
                    onClick={() => {
                      setShowMobileServices(false);
                      InputRef.current.value = '';
                    }}
                  >
                    Clear
                  </Button>
                  <Button
                    variant='outlined'
                    type='submit'
                    color='success'
                    disabled={loading}
                  >
                    Submit
                  </Button>
                </div>
                <Typography className='text-center text-gray-600  mt-4 mb-6'>
                  Back to signIn?
                  <span
                    onClick={() => navigate('/signin')}
                    className='text-blue-600 cursor-pointer hover:underline'
                  >
                    Click Here
                  </span>
                </Typography>

                {loading && <Spinner asOverlay={true} />}
              </Form>
            )}
          </Formik>
        </div>
        <Modal
          open={open}
          slots={{
            transition: Transition,
          }}
          onClose={() => setOpen(false)}
          aria-labelledby='modal-modal-title'
          aria-describedby='modal-modal-description'
        >
          <div className='flex justify-center items-center h-full '>
            <div className='max-w-md bg-white rounded-lg p-6'>
              <p className='text-center text-green-500 text-2xl font-semibold'>
                Application Successful !
              </p>
              <p className='text-center'>
                Your Applicaiton has submitted successfully ,we received your
                details.
              </p>
              <p className='text-center mt-2 font-semibold'>
                we will getback to you soon.
              </p>

              <div className='text-center'>
                <Button
                  className='mx-auto '
                  variant='contained'
                  color='success'
                  onClick={() => setOpen(false)}
                >
                  OK
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};
export default RegistrationPage;
